import {combineLatest} from 'rxjs';
import {filter, map, shareReplay, startWith} from 'rxjs/operators';
import {wwData$} from './worker-data';
import {spot$} from './spot';
import Msg = ww.Msg;

export const spotMarketCache$ = wwData$.pipe(
  filter((o: Msg<any>) => o.type === 'market24h-spot'),
  map((o: Msg<any>): Map<string, SpotMarket> => o.data),
  filter(Boolean),
  startWith(new Map<string, SpotMarket>()),
  shareReplay(1)
);

export const currentSpotMarket$ = combineLatest([spot$, spotMarketCache$]).pipe(
  map(([spot, spotMarketCache]) => spotMarketCache.get(spot.symbol) || createInitMarket()),
  filter(Boolean),
  startWith(createInitMarket()),
  shareReplay(1)
);

function createInitMarket(): SpotMarket {
  return {
    type: 'Spot',
    symbol: '',
    status: 'Listed',
    displaySymbol: '',
    openEp: 0,
    open: '--',
    closeEp: 0,
    close: '--',
    highEp: 0,
    high: '--',
    lowEp: 0,
    low: '--',
    indexPriceEp: 0,
    indexPrice: '--',
    turnoverEv: 0,
    turnoverStr: '--',
    volume24hStr: '--',
    change24hEp: 0,
    change24hStr: '--',
    changePercent: 0,
    changePercentStr: '--',

    baseCurrency: '',
    displayBaseCurrency: '',
    bid1Ep: 0,
    ask1Ep: 0,
    name: '-',
    closeMoneyWU: '--',
    klineData: [],
    stStatus: 0,
    hasZeroFee: false,
    isNew: false,
  };
}
